module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAElBMVEUAAAD///////////////////8+Uq06AAAABnRSTlMAIjNVZoiNigfSAAAALklEQVQI12MwYGBgZlBlYAhiYApgVWAQUA1iZHBhUnBhYHFgcWBgcHFhYAAyGQBF8QOo4TaPTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/doubl_arr_bottom.png
// module id = 662
// module chunks = 0